export const NOTIFICATIONS_VIEW_LIST = 'NOTIFICATIONS_VIEW_LIST';
